import { FaBrain, FaRobot, FaPlug, FaChartLine, FaClock, FaCloud, FaCogs, FaCode } from 'react-icons/fa';

const features = [
  {
    id: 1,
    icon: <FaBrain />,
    title: 'AI-Powered Insights',
    description: 'Uncover hidden trends in your data with intelligent insights.',
  },
  {
    id: 2,
    icon: <FaRobot />,
    title: 'Intelligent Automation',
    description: 'Automate repetitive tasks & complex workflows using AI algorithms.',
  },
  {
    id: 3,
    icon: <FaPlug />,
    title: 'Seamless Integration',
    description: 'Connect with your existing tools ensuring smooth tech ecosystem.',
  },
  {
    id: 4,
    icon: <FaChartLine />,
    title: 'Scalable Analytics',
    description: 'Analyze massive datasets in real-time with a scalable infrastructure.',
  },
  {
    id: 5,
    icon: <FaClock />,
    title: 'Real-Time Monitoring',
    description: 'Track performance instantly with live data dashboards and alerts.',
  },
  {
    id: 6,
    icon: <FaCloud />,
    title: 'Cloud Infrastructure',
    description: 'Ensure your data is safe with multi-layer security protocols.',
  },
  {
    id: 7,
    icon: <FaCogs />,
    title: 'Custom AI Models',
    description: 'Train and deploy models tailored to your unique business needs.',
  },
  {
    id: 8,
    icon: <FaCode />,
    title: 'Advanced API Access',
    description: 'Integrate effortlessly with your existing tools through flexible APIs.',
  },
];

export default features;